module.exports = __webpack_public_path__ + "static/white1-6a86f7027b1a81a51e2651acaaad00c3.png";